import { currencyLocaleMappings } from '../constants/dataConstants';

export const CurrencyFormatter = (currency: string, revenue: number, noDataAvailable?: string) => {
  // Define Thai currency codes
  const thaiCurrencyCodes = ['BHT', 'TBH', 'THB'];
  const currencyCode = thaiCurrencyCodes.includes(currency) ? 'THB' : currency;
  const locale = currencyLocaleMappings[currencyCode] || 'en-US';

  if (revenue === null || revenue === undefined || isNaN(revenue)) {
    return noDataAvailable || 'No data available';
  }

  return currency
    ? revenue?.toLocaleString(locale, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    : revenue;
};

export const CurrencyInputFormatter = (
  currencyCode: string,
  amount: number,
  allowRounding: boolean = false
): string => {
  if (currencyCode === null || currencyCode === undefined || isNaN(amount)) {
    return '---';
  }

  const locale = currencyLocaleMappings[currencyCode] || 'en-US';

  const valueToFormat = allowRounding ? Math.round(amount) : amount;
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: allowRounding ? 0 : 2,
    maximumFractionDigits: allowRounding ? 0 : 2,
  }).format(valueToFormat);

  return formatted;
};
